/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptions, FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptionsFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptionsToJSON, } from './FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptions';
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFxIdLoginFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestFxIdLoginFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFxIdLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFxIdLoginToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestFxIdLoginToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFxIdLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoFxIdLoginOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromSocialRequestFxIdLogin.js.map